module.exports = __webpack_public_path__ + "static/media/tree-palm.a8dc402b.svg";